import React, { useEffect, useState } from "react";

/*
 * ╔══════════════════════════════════════════╗
 * ║  CreatorMessage — wiadomość od twórcy   ║
 * ╚══════════════════════════════════════════╝
 *
 * Komponent sam pobiera dane z backendu.
 * Żeby pokazać wiadomość — wyślij POST /api/creator-message z backendu lub curl:
 *
 *   curl -X POST https://twoja-domena/api/creator-message \
 *     -H "Content-Type: application/json" \
 *     -H "X-Admin-Secret: TWOJ_ADMIN_SECRET" \
 *     -d '{"title":"Nowe wyzwania!","message":"...","date_label":"12 marca 2026"}'
 *
 * Żeby ukryć:
 *   curl -X POST https://twoja-domena/api/creator-message/deactivate \
 *     -H "X-Admin-Secret: TWOJ_ADMIN_SECRET"
 */

const API_BASE = process.env.REACT_APP_API_URL || "";

export default function CreatorMessage() {
  const [data, setData] = useState(null);
  const [isNew, setIsNew] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE}/api/creator-message`)
      .then((r) => r.json())
      .then((json) => {
        if (!json.active) { setData(false); return; }

        const storageKey = `cm_seen_${json.id}`;
        const seen = localStorage.getItem(storageKey);

        if (!seen) {
          setIsNew(true);
          localStorage.setItem(storageKey, "1");
        }

        setData(json);
      })
      .catch(() => setData(false));
  }, []);

  if (!data) return null;

  return (
    <div className="cm-wrapper">
      <div className="cm-connector">
        <div className="cm-connector-line" />
        <div className="cm-connector-diamond" />
        <div className="cm-connector-line" />
      </div>

      <div className="cm-card">
        <div className="cm-corner cm-corner--tl" />
        <div className="cm-corner cm-corner--tr" />

        <div className="cm-header">
          <div className="cm-avatar">
            <img src="/gm.png" alt="Dev" className="cm-avatar-img" />
          </div>
          <div className="cm-header-text">
            <span className="cm-from">Developer</span>
            {data.date_label && <span className="cm-date">{data.date_label}</span>}
          </div>
          {isNew && (
            <div className="cm-badge">
              <span className="cm-badge-dot" />
              New
            </div>
          )}
        </div>

        <div className="cm-sep" />

        {data.title && <h4 className="cm-title">{data.title}</h4>}
        <p className="cm-message">{data.message}</p>

        <div className="cm-glow" />
      </div>
    </div>
  );
}